import { FlatTreeControl } from "@angular/cdk/tree";
import { MatTreeFlatDataSource, MatTreeFlattener } from "@angular/material/tree";
import { FilterFlowTypeEnum } from "../../core/interfaces/filter-type.enum";
import { IVariable } from "../../core/interfaces/variable.interface";

class TreeNode {
  name: string;
  label?: string;
  tag?: string;
  filterFlowType?: FilterFlowTypeEnum;
  filterTreeName?: string;
  dataType?: string;
  share?: string;
  unit?: string;
  children?: TreeNode[];
}

class TreeFlatNode {
  expandable: boolean;
  name: string;
  tag: string;
  level: number;
  filterFlowType?: FilterFlowTypeEnum;
  filterTreeName?: string;
}

export function treeFlattenerFunction(tree: any[]) {
  let flatNodeMap = new Map<TreeFlatNode, TreeNode>();
  let nestedNodeMap = new Map<TreeNode, TreeFlatNode>();
  let treeControl: FlatTreeControl<TreeFlatNode>;
  let treeFlattener: MatTreeFlattener<TreeNode, TreeFlatNode>;
  let dataSource: MatTreeFlatDataSource<TreeNode, TreeFlatNode>;

  function getLevel (node: TreeFlatNode) {
    return node.level
  };

  function isExpandable (node: TreeFlatNode) {
    return node.expandable;
  }

  function getChildren (node: TreeNode): TreeNode[] {
    return node.children;
  }

  function hasChild (_: number, _nodeData: TreeFlatNode) {
    return _nodeData.expandable;
  }

  function hasNoContent (_: number, _nodeData: TreeFlatNode) {
    return _nodeData.name === '';
  }

  function transformer (node: TreeNode, level: number) {
    const existingNode = nestedNodeMap.get(node);
    const flatNode = existingNode && existingNode.name === node.name
        ? existingNode
        : new TreeFlatNode();
    flatNode.name = node.label ? node.label : node.name;
    flatNode.tag = node.tag;
    flatNode.level = level;
    flatNode.expandable = !!node.children;
    flatNode.filterFlowType = node?.filterFlowType ? node.filterFlowType : null;
    flatNode.filterTreeName = node?.filterTreeName ? node.filterTreeName : null;
    flatNodeMap.set(flatNode, node);
    nestedNodeMap.set(node, flatNode);
    return flatNode;
  }

  treeFlattener = new MatTreeFlattener(transformer, getLevel, isExpandable, getChildren);
  treeControl = new FlatTreeControl<TreeFlatNode>(getLevel, isExpandable);
  dataSource = new MatTreeFlatDataSource(treeControl, treeFlattener);

  dataSource.data = tree;

  let flatTree: {[key: string]: IVariable};

  flatTree = treeControl.dataNodes.reduce((acc, cur) => {
    return {...acc, [cur.tag]: cur};
  }, {})

  return flatTree;
}